define('app/filters/controls/StringFilterControl',['require','glu/itemView','config','hbs!./TextFilterControl.hbs'],function(require) {
	'use strict';

	var ItemView = require('glu/itemView'),
		config = require('config');

	return ItemView.extend({
		template: require('hbs!./TextFilterControl.hbs'),
		tagName: 'span',

		ui: {
			$value: '[name=value]',
			$errorMsg: '[id=errorMsg]'
		},

		events: {
			'keyup [name=value]': 'updateModel',
			'change [name=value]': 'updateModel'
		},

		initialize: function() {
			this.model.setArity(1);
		},

		serializeData: function() {
			return this;
		},

		value: function() {
			return this.model.getValue(0);
		},

		readOnlyHtml: function() {
			return '<p>read only html</p>';
		},

		updateModel: function() {
			var val = this.ui.$value.val();

			// validate the input: ONLY alphanumeric, space, - , . ' ( ) _ " ? : ; @
			var isValid = (val.trim() === '' || config.textRegex.test(val));
			if (isValid) {
				this.ui.$value.removeClass('input-dialog-item-error');
				this.model.setValue(0, val);
				this.ui.$errorMsg.hide();
			} else {
				this.ui.$value.addClass('input-dialog-item-error');
				this.model.setValue(0, null);
				this.ui.$errorMsg.show();
			}
		}
	});

});

